var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.1452 21.6613C5.33727 21.6613 0.629036 16.953 0.629036 11.1452C0.629036 5.33726 5.33727 0.629028 11.1452 0.629028C16.9531 0.629028 21.6613 5.33726 21.6613 11.1452C21.6613 13.5753 20.837 15.8129 19.4527 17.5937L26.5343 24.6753L24.6753 26.5343L17.5937 19.4527C15.813 20.837 13.5753 21.6613 11.1452 21.6613ZM19.0322 11.1451C19.0322 15.5011 15.5011 19.0322 11.1452 19.0322C6.78924 19.0322 3.25806 15.5011 3.25806 11.1451C3.25806 6.78922 6.78924 3.25805 11.1452 3.25805C15.5011 3.25805 19.0322 6.78922 19.0322 11.1451Z","fill":"#9A9A9A"}));
}

Search.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = Search;

Search.default = Search;
